import JiaolianPicker from './CaipanPicker.vue'
export default JiaolianPicker